<template>
  <div>
    <div class="page-neck">
      <div class="breadcumb-area">
        <div class="item-style" v-for="(item, key) in items" :key="key">
          <div v-if="key < items.length-1">
            <router-link
              :to="{ name: item.link, params: { activeTab: item.activeTab || 0 }}"
              style="color: white"
            >{{ item.label }}</router-link>
            <span style="margin: 0rem 0.5rem;">></span>
          </div>
          <div v-else>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="practice-area">
        <div class="content-container">
          <div class="content">
            <slot name="content"></slot>
          </div>
          <div class="fields-and-buttons">
            <div class="fields-area">
              <div>
                <slot name="specialFields"></slot>
              </div>
              <div v-for="(obj, index) in fields" :key="index" class="field-style">
                <span class="label-style">{{obj.label}}</span>
                <div class="highlight" v-html="highlight(obj.value)"></div>
              </div>
            </div>
            <div class="buttons-area">
              <slot name="other-buttons"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'

const PageWrapper = Vue.extend({
  name: 'PageWrapper',
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      videoUrl: '',
      toShowVideo: false
    }
  },
  methods: {
    highlight (str) {
      let renderHtml = ''
      for (let i = 0; i < str.length; i++) {
        let ch = str.charAt(i)
        if ((ch >= '0' && ch <= '9') || ch === '.') {
          renderHtml += `<span class="number-style">${ch}</span>`
        } else {
          renderHtml += `<span class="unitLabel-style">${ch}</span>`
        }
      }
      return renderHtml
    }
  }
})

export default PageWrapper
</script>

<style lang='scss' scoped>
.page-neck {
  height: 70px;
  background-color: #26948b;
  display: flex;
}
.breadcumb-area {
  width: 1024px;
  margin: auto;
  text-align: left;
  vertical-align: middle;
  color: white;
  padding-left: 1.2rem;
}
.item-style {
  display: inline-block;
}

.page-body {
  height: 760px;
  background-image: url("../../assets/newest_background.png");
  padding: 3rem 1rem;
  display: flex;
  justify-content: center;
}
.practice-area {
  display: flex;
  width: 1024px;
  height: 100%;
  background-color: #035f36;
  border-radius: 20px;
}

.content-container {
  display: flex;
  width: 1024px;
  margin: 3rem; //30px 10px 30px 20px;
}
.content {
  border: 3px #ffffff solid;
  border-radius: 20px;
  width: 80%;
}
.fields-and-buttons {
  width: 20%;
  display: flex;
  flex-direction: column;
  margin-left: 1.5rem;
}

.fields-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 70%;
  width: 100%;
}
.buttons-area {
  display: flex;
  flex-direction: column;
  height: 30%;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}

.field-style {
  background-color: #ffffff;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 5px;
  display: flex;
  padding: 0px 10px 0px 10px;
  align-items: center;
  padding: 0.3rem;
  height: auto;
  justify-content: space-between;
}
</style>
